import React, { createContext, useContext, useState } from 'react'
import Profile from './Profile'

const ProfileModalContext = createContext(null)

export function ProfileModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)

  const openProfile = () => setIsOpen(true)
  const closeProfile = () => setIsOpen(false)

  return (
    <ProfileModalContext.Provider value={{ openProfile, closeProfile }}>
      {children}
      <Profile isOpen={isOpen} onClose={closeProfile} />
    </ProfileModalContext.Provider>
  )
}

export function useProfileModal() {
  const ctx = useContext(ProfileModalContext)
  return ctx || { openProfile: () => {}, closeProfile: () => {} }
}
